import styled from 'styled-components';

export const Wrapper = styled.div`
	margin-top: 30px;
	text-align: left;
`;

export const WidthWrapper = styled.div`
	margin-bottom: 20px;
`;

export const Width = styled.div`
	margin-bottom: 5px;
`;

export const HeightWrapper = styled.div`
	margin-bottom: 20px;
`;

export const Height = styled.div`
	margin-bottom: 5px;
`;

export const MinesWrapper = styled.div`
	margin-bottom: 30px;
`;

export const Mines = styled.div`
	margin-bottom: 5px;
`;